import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectSelector = ({ selectedProject }) => {
  return (
    <div className="bg-card rounded-xl p-4 sm:p-6 border border-border">
      <div className="flex items-center">
        <Icon name="FolderOpen" size={24} className="mr-3 text-primary flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <label className="text-sm font-medium text-muted-foreground block mb-2">
            Proyecto Actual
          </label>
          <div className="w-full px-4 py-3 bg-background border border-border rounded-lg">
            <p className="text-lg font-semibold text-foreground">
              Residencial 3 Volcanes
            </p>
          </div>
        </div>
      </div>

      {selectedProject && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div>
              <p className="text-xs text-muted-foreground mb-1">Estado</p>
              <div className="flex items-center">
                <div className={`w-2 h-2 rounded-full mr-2 ${
                  selectedProject?.status === 'active' ? 'bg-green-500' :
                  selectedProject?.status === 'planning' ? 'bg-yellow-500' :
                  selectedProject?.status === 'completed'? 'bg-blue-500' : 'bg-gray-500'
                }`} />
                <span className="text-sm font-medium text-foreground capitalize">
                  {selectedProject?.status === 'active' ? 'Activo' : selectedProject?.status}
                </span>
              </div>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Ubicación</p>
              <p className="text-sm font-medium text-foreground">{selectedProject?.location || 'Arequipa, Perú'}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Descripción</p>
              <p className="text-sm font-medium text-foreground truncate">
                {selectedProject?.description || 'Proyecto inmobiliario principal'}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectSelector;